import { Dialog } from '@headlessui/react';
import { XIcon } from 'lucide-react';
import i18n from '@/settings/i18n';
import CountryList from '../../Navbar/ExtendedNavbar/TopNavbar/StoreSelector/CountryList';

const t = i18n.init('shared');

export default function LangCountrySelectorModal(props: {
  isOpen: boolean;
  onClose: (data?: {
    store?: string;
    lang?: string;
    storeLink?: string;
  }) => void;
}) {
  const { isOpen, onClose } = props;

  return (
    <Dialog
      as="div"
      className="fixed inset-0 z-[70] overflow-y-auto"
      onClose={() => onClose()}
      open={isOpen}
    >
      <div className="flex min-h-screen items-start justify-center p-4 text-center sm:items-center sm:p-0">
        <Dialog.Overlay className="fixed inset-0 bg-gray-700 opacity-50" />

        {/* This element is to trick the browser into centering the modal contents. */}
        <span
          className="inline-block h-screen align-middle "
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="relative z-[70] mx-auto inline-block w-full overflow-hidden rounded-xl bg-white p-3 text-left shadow-lg sm:min-h-max sm:max-w-[420px]">
          <div className="flex items-center justify-between px-3 pb-2">
            <Dialog.Title className="text-base font-bold text-gray-700">
              {t`Choose your country`}
            </Dialog.Title>
            <button
              type="button"
              onClick={() => onClose()}
              aria-label={t`Close`}
              className="outline-none transition-transform duration-100 hover:scale-105"
            >
              <XIcon className="h-5 w-5" />
            </button>
          </div>
          <CountryList
            onClose={() => onClose()}
            listClassName="max-h-[min(460px,60vh)]"
            onSelect={({ store, locale, href }) =>
              onClose({ store, lang: locale, storeLink: href })
            }
          />
        </div>
      </div>
    </Dialog>
  );
}
